module.exports = __webpack_public_path__ + "img/item-8.d59032b4.png";